// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2gN7s","rootSuccess":"CompleteLink_rootSuccess__n2TL2","rootFailure":"CompleteLink_rootFailure__3g4dK","isDisabled":"CompleteLink_isDisabled__1rBqI"};